export default "__VITE_ASSET__BhLQHY2S__"